import * as moduleActions from '../moduleActions';

export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const UPDATE_VIEW_NOTIFICATION = 'UPDATE_VIEW_NOTIFICATION';
export const LOG_ERROR = 'LOG_ERROR';




export const removeNotification =(data)=>{
    
    return {
        type: REMOVE_NOTIFICATION,
        data: data
    }
};

export const updateViewNotification =(data)=>{
    
    return {
        type: UPDATE_VIEW_NOTIFICATION,
        data: data
    }
};

export const addNotification =(type,title,description)=>{
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    var notification = {date:yyyy + '-' + mm + '-' + dd +" "+ today.getHours().toString().padStart(2, '0') + ":" +today.getMinutes().toString().padStart(2, '0'),type:type,isRead:false,title:title,description:description};
    return {
        type: ADD_NOTIFICATION,
        data: notification
    }
};

export const logError = (error,title,endPoint)=>{
    return (dispatch)=>{
        dispatch(moduleActions.addModuleData("NOTIFICATION",
            {
                type:"exclamation-triangle",
                title:title,
                description : error.message +" using endpoint: "+endPoint
            })
        );
}

}

